import { render } from "./Beneficiary.vue?vue&type=template&id=24cda9f5&ts=true"
import script from "./Beneficiary.vue?vue&type=script&lang=ts"
export * from "./Beneficiary.vue?vue&type=script&lang=ts"

import "./Beneficiary.vue?vue&type=style&index=0&id=24cda9f5&lang=css"

import exportComponent from "/Users/pradipdobariya/Documents/projects/DMA Global/caprock-merchant-old/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__